module.exports = function() {
  return new Worker(__webpack_public_path__ + "9b7ba9397ff5c947fd97.worker.js");
};